import { Skeleton } from "@mui/material";

const FieldCardSkeleton = ({ variant, width, height }) => {
  return (
    <Skeleton
      variant={variant}
      width={width}
      height={height}
      animation="wave"
    />
  );
};

export default FieldCardSkeleton;
